module.exports = __webpack_public_path__ + "img/steak-2.37b42e25.png";